const GA_ID = process.env.REACT_APP_GA_ID;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  initialized = true;

  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID);
  }

  if (PIXEL_ID && !window.fbq) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
  }
}

export function trackPageView(path) {
  if (window.gtag && GA_ID) window.gtag("event", "page_view", { page_path: path });
  if (window.fbq) window.fbq("track", "PageView");
}

export function track(name, params = {}) {
  if (window.gtag) window.gtag("event", name, params);
  if (window.fbq) window.fbq("trackCustom", name, params);
}

export function trackViewContent(label) {
  if (window.gtag) window.gtag("event", "view_content", { content_name: label });
  if (window.fbq) window.fbq("track", "ViewContent", { content_name: label });
}

export function trackOutbound(label) {
  if (window.gtag)
    window.gtag("event", "outbound_store_click", { cta: label, transport_type: "beacon" });
  if (window.fbq) {
    window.fbq("track", "InitiateCheckout", { content_name: label });
    window.fbq("trackCustom", "CollectClick", { cta: label });
  }
}

export function initScrollDepth() {
  const fired = new Set();
  const onScroll = () => {
    const h = document.documentElement;
    const depth = ((h.scrollTop + window.innerHeight) / h.scrollHeight) * 100;
    [25, 50, 75, 100].forEach((m) => {
      if (depth >= m && !fired.has(m)) {
        fired.add(m);
        track("scroll_depth", { percent: m });
      }
    });
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  return () => window.removeEventListener("scroll", onScroll);
}
